import type { Variant } from '@chessbut/engine';
import { variantDay } from '@chessbut/shared';
import type { ReactNode } from 'react';

/** The player's initial in a quiet circle (no photos, no colours: the day's accent is the only colour). */
export function Avatar({ name, size = 36 }: { name: string; size?: number }) {
  return (
    <span className="avatar" style={{ width: size, height: size, fontSize: size * 0.42 }}>
      {name.trim().slice(0, 1).toUpperCase() || '?'}
    </span>
  );
}

export function DayBadge({ variant, day, isNew, past }: { variant?: Variant; day?: number | null; isNew?: boolean; past?: boolean }) {
  const d = day ?? (variant ? variantDay(variant.id) : null);
  if (d === null || d === undefined) return null;
  return <span className={`day-badge ${isNew ? 'is-new' : ''} ${past ? 'is-past' : ''}`}>Day {d}</span>;
}

/** The brand headline: "chess, but" with the twist highlighted in the variant colour. */
export function ChessBut({ variant, as: Tag = 'h2', twist }: { variant?: Variant; as?: 'h1' | 'h2' | 'h3'; twist?: string }) {
  return (
    <Tag className="chessbut">
      <span className="lead">
        chess, <span className="but">but</span>
      </span>
      <span className="twist">{twist ?? variant?.info.but}</span>
    </Tag>
  );
}

/** Renders "**bold**" segments; everything else is plain text. */
export function Rich({ text }: { text: string }): ReactNode {
  return text.split(/(\*\*[^*]+\*\*)/).map((part, i) => (part.startsWith('**') ? <b key={i}>{part.slice(2, -2)}</b> : part));
}

/** Wraps a page so `--variant` (the day's accent) applies to everything inside. */
export function variantStyle(variant: Variant | null | undefined) {
  return variant ? ({ ['--variant' as string]: variant.info.accent } as Record<string, string>) : undefined;
}
